// Item codes are dash-separated numeric segments, e.g. "1-4", "10-2", "2-12".
// A plain string sort would put "10-2" before "2-12" (lexicographic), so
// each segment is compared numerically instead.
export function compareItemCode(a: string, b: string): number {
  const aParts = a.split("-").map(Number);
  const bParts = b.split("-").map(Number);
  const len = Math.max(aParts.length, bParts.length);
  for (let i = 0; i < len; i++) {
    const diff = (aParts[i] ?? 0) - (bParts[i] ?? 0);
    if (diff !== 0) return diff;
  }
  return 0;
}

// Returns a new array sorted ascending by itemCode — the input array (and
// the API response it came from) is never mutated.
export function sortByItemCode<T extends { itemCode: string }>(
  items: T[],
): T[] {
  return [...items].sort((a, b) => compareItemCode(a.itemCode, b.itemCode));
}
